module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"loading":"Loading...","code_copied":"Copied coupon code to clipboard"},"ja":{"loading":"お待ちください 。。。","code_copied":"クーポンコードをコピーしました"}}')
  delete Component.options._Ctor
}
